import { useCallback, useEffect, useRef, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = (path, opts = {}) =>
  fetch(`${API}${path}`, { credentials: "include", headers: { "Content-Type": "application/json" }, ...opts });

export const loginWithGoogle = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const processed = useRef(false);

  const refresh = useCallback(async () => {
    const r = await api("/auth/me").catch(() => null);
    const u = r && r.ok ? await r.json() : null;
    setUser(u);
    setLoading(false);
    return u;
  }, []);

  useEffect(() => {
    const m = window.location.hash.match(/session_id=([^&]+)/);
    if (!m) { refresh(); return; }
    if (processed.current) return;
    processed.current = true;
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
    api("/auth/session", { method: "POST", body: JSON.stringify({ session_id: m[1] }) })
      .then((r) => (r.ok ? r.json() : null))
      .then((u) => { setUser(u); setLoading(false); })
      .catch(() => setLoading(false));
  }, [refresh]);

  return { user, loading, refresh };
};
